import { lazy } from "react";
import { TEMA_ROUTE_IDS } from "./temaRouteConstants";
import { TEMA_PAGE_LOADERS } from "./pageLoaders";
import { loadWithChunkRetry } from "../utils/loadWithChunkRetry";

function lazyFromLoader(routeId) {
  const loader = TEMA_PAGE_LOADERS[routeId];
  return lazy(() =>
    loadWithChunkRetry(() =>
      loader.load().then((module) => ({ default: module[loader.exportName] })),
    ),
  );
}

export const LazyDashboardPage = lazyFromLoader(TEMA_ROUTE_IDS.DASHBOARD);
export const LazySectionHubPage = lazyFromLoader(TEMA_ROUTE_IDS.TEACH_PREPARE);
export const LazyQuickSheetsPage = lazyFromLoader(TEMA_ROUTE_IDS.QUICK_SHEETS);
export const LazyConceptQuestionsPage = lazyFromLoader(
  TEMA_ROUTE_IDS.CONCEPT_QUESTIONS,
);
export const LazyQuestionVariationsPage = lazyFromLoader(
  TEMA_ROUTE_IDS.QUESTION_VARIATIONS,
);
export const LazyQuickAssessmentPage = lazyFromLoader(
  TEMA_ROUTE_IDS.QUICK_ASSESSMENT,
);
export const LazyTeachThisTopicPage = lazyFromLoader(
  TEMA_ROUTE_IDS.TEACH_THIS_TOPIC,
);
export const LazyExplainDifferentlyPage = lazyFromLoader(
  TEMA_ROUTE_IDS.EXPLAIN_DIFFERENTLY,
);
export const LazyContentSimplifierPage = lazyFromLoader(
  TEMA_ROUTE_IDS.CONTENT_SIMPLIFIER,
);
export const LazyQuestionPaperPage = lazyFromLoader(TEMA_ROUTE_IDS.QUESTION_PAPER);
export const LazySectionBuilderPage = lazyFromLoader(
  TEMA_ROUTE_IDS.SECTION_BUILDER,
);
export const LazyDifficultyBalancerPage = lazyFromLoader(
  TEMA_ROUTE_IDS.DIFFICULTY_BALANCER,
);
export const LazyDoubtSolverPage = lazyFromLoader(TEMA_ROUTE_IDS.DOUBT_SOLVER);
export const LazySlideDeckGeneratorPage = lazyFromLoader(
  TEMA_ROUTE_IDS.SLIDE_DECK_GENERATOR,
);
export const LazyProjectBuilderPage = lazyFromLoader(TEMA_ROUTE_IDS.PROJECT_BUILDER);
export const LazyActivityGeneratorPage = lazyFromLoader(
  TEMA_ROUTE_IDS.ACTIVITY_GENERATOR,
);
export const LazyRealWorldTaskGeneratorPage = lazyFromLoader(
  TEMA_ROUTE_IDS.REAL_WORLD_TASK,
);
export const LazyLibraryPage = lazyFromLoader(TEMA_ROUTE_IDS.LIBRARY);
export const LazyBillingPage = lazyFromLoader(TEMA_ROUTE_IDS.BILLING);
export const LazyCertificationPage = lazyFromLoader(TEMA_ROUTE_IDS.CERTIFICATION);
export const LazyAifeVerifyPage = lazyFromLoader(TEMA_ROUTE_IDS.AIFE_VERIFY);
export const LazyTeacherOnboardingPage = lazyFromLoader(TEMA_ROUTE_IDS.ONBOARDING);
